import React, { memo } from 'react';
import PropTypes from 'prop-types';

const HospitalsTableMobile = ({ hospitals }) => {
  return (
    <div className="cases-table-mobile">
      {hospitals.map((hospital) => {
        return (
          <div key={hospital.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{hospital.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {hospital.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

HospitalsTableMobile.propTypes = {
  hospitals: PropTypes.array,
};

export default memo(HospitalsTableMobile);
